
const texts = {
    title: 'Complete datos y agregue personas firmantes',
    input: {
        tituloDoc:'Título del Documento*',
        descripcion:'Descripción',
        fechaIn:'Fecha de Inicio*',
        fechaFin: 'Fecha de Fin*',
    },
    subtitle: 'Personas firmantes*',
    errorMessages: {
      rechazo:'EF003: No se pudo completar la acción. Probá de nuevo en unos minutos. Si sigue el problema, escribí a soporte.',
      networkError: 'EF001: Hubo un error de conexión con el servidor. Probá otra vez en unos minutos.',
      invalidNavigation: 'EF004: La dirección web (URL) no es válida.',
      peticionTardo:'EF002: El servidor no respondió. Probá de nuevo en unos minutos. Si el problema sigue, escribí a soporte.',
    },
    validacionMensajes:{
        ingreseTitulo:'EF0015: Escribe un título para el documento.',
        fechaInicio:'EF0016: Elige una fecha de inicio para el proceso de firmas.',
        fechaInicioAnterior:'EF0017: La fecha de inicio no puede ser anterior a la actual.',
        fechaFin: 'EF0018: Selecciona una fecha de finalización para el proceso de firmas.',
        fechaFinAnterior: 'EF0019: La fecha de fin debe ser posterior a la fecha de inicio.',
        listaVacia: 'EF0020: Debe agregar al menos un firmante.'
    },
    buttons: {
      send: 'Enviar documento',
    },
  };
  
  export default texts;
  